import React, { Component } from "react";
import Popup from "reactjs-popup";
import { getStaticText } from '../../lables/lablesService';
import Form from '../../components/form-component/form';
import Settings from "./api/settings";

import './settingPage.css'



class SettingsPage extends Component {

    constructor (props) {
        super(props);

        this.form_title = '';
        this.form_fields = {};
        this.form_sections = {};
        this.form_data_type = '';

        this.state = {
            'show_popup' : false
        };
    }


    async toggleEditForm ( settings_key = '' ) {
        if ( !this.state.show_popup ) {
            let name = '';
            let type = 'text';
            let value = '';

            let where_parameters = {};
            switch ( settings_key ) {
                case 'page_contacts':
                        name = 'content_of_page_contacts';
                        where_parameters = {'name' : name};
                        this.form_title = getStaticText('settings_tbody_contact_page_label');
                        this.form_data_type = 'json';
                        this.form_sections = {
                            'content_section' : {
                                'fields' : {
                                    'value' : {
                                        'type' : 'input_html',
                                        'name' : 'value',
                                        'label' :  getStaticText('settings_form_content_label')
                                    }
                                }
                            }
                        };
                    break;

                case 'page_schedules':
                        name = 'content_of_page_schedules';
                        where_parameters = {'name' : name};
                        this.form_title = getStaticText('settings_tbody_schedules_page_label');
                        this.form_data_type = 'json';
                        this.form_sections = {
                            'content_section' : {
                                'fields' : {
                                    'value' : {
                                        'type' : 'input_textarea',
                                        'name' : 'value',
                                        'label' :  getStaticText('settings_form_content_label')
                                    }
                                }
                            }
                        };
                    break;

                case 'page_online_map':
                        name = 'content_of_page_online_map';
                        where_parameters = {'name' : name};
                        this.form_title = getStaticText('settings_tbody_online_map_page_label');
                        this.form_data_type = 'json';
                        this.form_sections = {
                            'content_section' : {
                                'fields' : {
                                    'value' : {
                                        'type' : 'input_textarea',
                                        'name' : 'value',
                                        'label' :  getStaticText('settings_form_content_label')
                                    }
                                }
                            }
                        };
                    break;

                case 'page_home':
                        name = 'content_of_page_home';
                        where_parameters = {'name' : name};
                        this.form_title = getStaticText('settings_tbody_home_page_label');
                        this.form_data_type = 'json';
                        this.form_sections = {
                            'content_section' : {
                                'fields' : {
                                    'value' : {
                                        'type' : 'input_html',
                                        'name' : 'value',
                                        'label' :  getStaticText('settings_form_content_label')
                                    }
                                }
                            }
                        };
                    break;

                default:
                   break;
            }

            let settings_list_response = await Settings.list({
                                                                'page' : 1,
                                                                'per_page' : 1,
                                                                'where' : where_parameters
                                                            });
            if ( typeof(settings_list_response.rows) !== 'undefined' && typeof(settings_list_response.rows[0]) !== 'undefined' ) {
                value = settings_list_response.rows[0].value;
            }

            this.form_fields = {
                'name' : name,
                'type' : type,
                'value' : value
            };
        }

        this.setState({
            'show_popup' : !this.state.show_popup
        });
    }


    async saveInfo ( info_from_form ) {
        let body_for_save = null;
        if ( this.form_data_type === 'json' ) {
            body_for_save = {};
            Object.assign(
                body_for_save,
                this.form_fields,
                info_from_form
            );
        } else if ( this.form_data_type === 'FormData' ) {
            body_for_save = info_from_form;
            body_for_save.append( 'name', this.form_fields.name );
            body_for_save.append( 'type', this.form_fields.type );
        }

        let saved = await Settings.add( body_for_save );
        if ( !saved ) {
            window.alert( getStaticText('save_error') );
        } else {
            window.alert( getStaticText('save_success') );
            this.toggleEditForm();
        }
    }


    render () {
        return (<div className="row">
                    <div className="col-lg-12">
                        <h2>{getStaticText('settings_section_title')}</h2>
                    </div>
                    <div className="col-lg-12 pt-3">
                        <div className="table-responsive">
                            <table className="table table-bordered table-hover">
                                <thead>
                                    <tr className="table-warning">
                                        <th>{getStaticText('settings_table_header_name_label')}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{getStaticText('settings_tbody_schedules_page_label')}</td>
                                        <td>
                                            <button 
                                                className="btn btn-sm btn-info text-white os-mr-1"
                                                title={getStaticText('settings_tbody_edit_button')}
                                                onClick={this.toggleEditForm.bind(this, 'page_schedules')}
                                            >
                                                <span className="fa fa-edit"></span>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{getStaticText('settings_tbody_online_map_page_label')}</td>
                                        <td>
                                            <button 
                                                className="btn btn-sm btn-info text-white os-mr-1"
                                                title={getStaticText('settings_tbody_edit_button')}
                                                onClick={this.toggleEditForm.bind(this, 'page_online_map')}
                                            >
                                                <span className="fa fa-edit"></span>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{getStaticText('settings_tbody_contact_page_label')}</td>
                                        <td>
                                            <button 
                                                className="btn btn-sm btn-info text-white os-mr-1"
                                                title={getStaticText('settings_tbody_edit_button')}
                                                onClick={this.toggleEditForm.bind(this, 'page_contacts')}
                                            >
                                                <span className="fa fa-edit"></span>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{getStaticText('settings_tbody_home_page_label')}</td>
                                        <td>
                                            <button 
                                                className="btn btn-sm btn-info text-white os-mr-1"
                                                title={getStaticText('settings_tbody_edit_button')}
                                                onClick={this.toggleEditForm.bind(this, 'page_home')}
                                            >
                                                <span className="fa fa-edit"></span>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <Popup
                        open={this.state.show_popup}
                        closeOnDocumentClick={false}
                        closeOnEscape={false}
                        className="os-popup"
                    >
                        <>
                            <div className="os-popup-header">
                                <span className="op-popup-title">
                                    {this.form_title}
                                </span>
                                <button
                                    onClick={this.toggleEditForm.bind(this)}
                                    className="os-popup-close-button"
                                >
                                    <i className="fa fa-times" />
                                </button>
                            </div>

                            <div className="os-popup-body">
                                <Form
                                    info={this.form_fields}
                                    sections={this.form_sections}
                                    formDataType={this.form_data_type}
                                    buttonLabel={getStaticText('settings_form_save_button_label')}
                                    saveInfoCallback={this.saveInfo.bind(this)}
                                />
                            </div>
                        </>
                    </Popup>
                </div>);
    }

}


export default SettingsPage;